import { FC } from 'react'
import { Info } from 'lucide-react'

// Components
import { MainPaymentMember } from './MainPaymentMember/MainPaymentMember'
import { SubPaymentMember } from './SubPaymentMember'

// Redux
import { useAppSelector } from '../../../store/hooks'
import {
  selectPayTabGrandTotalAccordion,
  selectRegistration,
} from '../../../store/registration/registrationSlice'
import { selectedEvent } from '../../../store/events/eventsSlice'

import { getCurrency } from '../../../helpers/payment'

interface PaymentMembersProps {
  isSplitBill: boolean
}

export const PaymentMembers: FC<PaymentMembersProps> = ({ isSplitBill }) => {
  const registration = useAppSelector(selectRegistration)
  const grandTotalAccordionData = useAppSelector(selectPayTabGrandTotalAccordion)
  const selectedEventR = useAppSelector(selectedEvent)

  const recipient = grandTotalAccordionData.amountByPerson.find(
    (person) => person.recipientId === registration?.userId
  )

  const members = grandTotalAccordionData.amountByPerson.filter(
    (person) => person.recipientId !== registration?.userId && person.amountToPay > 0
  )

  const currency = getCurrency(selectedEventR?.EventPaymentSettings?.currency)

  return (
    <div className="flex flex-col gap-4">
      {recipient?.recipientId && (
        <MainPaymentMember
          recipient={{
            recipientPicture: recipient.recipientPicture,
            recipientName: recipient.recipientName,
            amountToPay: recipient.amountToPay,
          }}
          isSplitBill={isSplitBill}
          currency={currency}
          totalPrice={grandTotalAccordionData.totalPrice}
        />
      )}
      {members?.[0] && isSplitBill && (
        <>
          <div className="flex flex-wrap gap-2">
            {members?.map((member) => (
              <SubPaymentMember
                key={member.recipientId}
                recipient={{
                  recipientPicture: member.recipientPicture,
                  recipientName: member.recipientName,
                  amountToPay: member.amountToPay,
                }}
                currency={currency}
              />
            ))}
          </div>
          <p className="text-sm text-black/50 flex gap-2 items-center">
            <Info className="w-4 min-w-4" />
            Team members will be registered now and sent a bill to pay separately
          </p>
        </>
      )}
    </div>
  )
}
